import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Popover, Typography } from '@mui/material';
import AumSelector from '../AumSelector';
import { AUM_UPDATED_EVENT } from '../dashboard/dashboardUtils';
import { normalizeAumValue } from '../../utils/aum';

export default function RiskOverviewAumControl({ aum, loading = false }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const normalizedAum = normalizeAumValue(aum);
    const refreshAum = (nextAum) => {
        window.dispatchEvent(new CustomEvent(AUM_UPDATED_EVENT, {
            detail: { aum: nextAum },
        }));
    };

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                onClick={(event) => setAnchorEl(event.currentTarget)}
                aria-label="Edit assets under management"
                aria-haspopup="dialog"
                aria-expanded={Boolean(anchorEl)}
                disabled={loading}
                sx={{
                    height: 34,
                    minWidth: 105,
                    px: 1.15,
                    borderColor: 'divider',
                    color: 'text.primary',
                    backgroundColor: 'background.paper',
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                    fontSize: '0.74rem',
                    fontWeight: 700,
                }}
            >
                AUM {normalizedAum == null ? '—' : `$${normalizedAum.toLocaleString()}`}
            </Button>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                PaperProps={{ role: 'dialog', 'aria-label': 'Edit assets under management', sx: { p: 2, mt: 0.5 } }}
            >
                <Box sx={{ display: 'grid', gap: 0.5 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>Assets under management</Typography>
                    <Typography variant="caption" color="text.secondary">
                        Account AUM used for risk and position sizing percentages.
                    </Typography>
                    <AumSelector aum={normalizedAum} refreshAum={refreshAum} hideTitle compact />
                </Box>
            </Popover>
        </>
    );
}

RiskOverviewAumControl.propTypes = {
    aum: PropTypes.number,
    loading: PropTypes.bool,
};
